// fontawesome stuffs
import { config, library, dom } from '@fortawesome/fontawesome-svg-core';

/*
  go to node_modules/@fortawesome/XXXXXXX to see available icon names
 */

// 1. import fa icons
// 1.1 regular icons <i class="fa fa-xxx"></i>
import { faPhoneAlt, faChevronDown, faCheck, faBars, faCaretRight, faChevronRight, faHome, faMapMarkerAlt, faCheckDouble, faStar, faSearch, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
// 1.2 brand icons <i class="fab fa-xxx"></i>
import { faFacebookSquare, faTwitterSquare, faLinkedin, faInstagramSquare, faGooglePlusSquare  } from '@fortawesome/free-brands-svg-icons';

/*
  for pseudo elements:
      XXX::before {
        display: none;
        font-style: normal;
        font-variant: normal;
        text-rendering: auto;
        -webkit-font-smoothing: antialiased;
        font-family: "Font Awesome 5 Solid", serif;
        font-weight: 900;
        content: "\f095";
      }
 */
config.searchPseudoElements = true;

// 2. add the imported icons to the library
library.add(
  faFacebookSquare,
  faTwitterSquare,
  faLinkedin,
  faInstagramSquare,
  faGooglePlusSquare,

  faHome,
  faMapMarkerAlt,
  faPhoneAlt,
  faChevronDown,
  faCheck,
  faBars,
  faCaretRight,
  faChevronRight,
  faCheckDouble,
  faStar,
  faSearch,
  faArrowLeft,
  faArrowRight
);

dom.watch();



// WEBPACK FOOTER //
// ./scripts/autoload/_fontawesome.js